export default __webpack_public_path__ + "static/uzenetkuldes-74d2636a30cbdbf949309714843ff860.pdf";